<template>
  <div>
    <div class="list">
      <div class="row">
        <input
          id="newInsight"
          type="text"
          v-model="input"
          placeholder="Enter a new Insight title"
        />
        <div class="button" id="add" @click="addInsight">
          <bg-icon name="fplus"></bg-icon>
        </div>
      </div>

      <div class="row" v-if="items.length > 0">
        <div class="headers">
          <p><b>Title</b></p>

          <p><b>Datapoints</b></p>
        </div>
      </div>
      <draggable
        tag="ul"
        class="w-full max-w-md"
        :list="items"
        :animation="200"
      >
        <div
          class="row"
          v-for="(item, index) in items"
          :key="index"
          @click="selectInsight(index)"
        >
          <div class="card">
            <div class="title">
              <span>{{ item.title }}</span>
            </div>

            <div class="datapoints">
              <span>{{ item.significant_points_ids.length }}</span>
            </div>
          </div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
import Draggable from "vuedraggable";
import bgField from "@/components/bg-field";
import BgIcon from "@/components/bg-icon";

export default {
  components: {
    bgField,
    Draggable,
    BgIcon,
  },
  props: ["items", "headers", "newInsight", "select"],
  data() {
    return {
      input: "",
    };
  },
  methods: {
    addInsight() {
      if (this.input) {
        this.newInsight({
          title: this.input,
          behavior_comment: "...",
          eeg_comment: "",
          explanation: "...",
          eye_tracking_comment: "",
          highlight_id: null,
          significant_points_ids: [],
          suggestion: "",
          summary: "...",
          touch_tracking_comment: "",
        });
        this.input = "";
      }
    },
    selectInsight(val) {
      this.select(val);
    },
  },
};
</script>
